import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'reqChannels');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'channels',
  type: 'get',
  slug: [
    {
      type: 'payload.query',
      queryParameter: 'type',
      selector: 'type',
    },
    {
      type: 'payload.query',
      queryParameter: 'program',
      selector: 'program',
    },
    {
      type: 'payload.query',
      queryParameter: 'string_query',
      selector: 'query',
    },
    {
      type: 'payload.query',
      queryParameter: 'status',
      selector: 'statuses',
    },
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
    {
      type: 'payload.query',
      queryParameter: 'excluded_ids',
      selector: 'excludedIds',
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/board/reqChannels.js